import React from 'react'

export default function Logo() {

    return (
        <>
            <div className='logo' >
                <img src='/assets/images/logo.webp' alt='logo' />
            </div>
        </>
    )
}
